import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import { buildContextIcon, buildContextLabel, type ChatContext } from './fidesChatPanelUtils';

interface FidesChatContextBarProps {
  contextData: ChatContext | null;
  contextLabel: string | null;
  contextLink: string | null;
  onNavigate: (path: string) => void;
}

const FidesChatContextBar: React.FC<FidesChatContextBarProps> = ({
  contextData,
  contextLabel,
  contextLink,
  onNavigate,
}) => {
  if (!contextLabel) {
    return null;
  }

  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        backgroundColor: '#f7f7f7',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Typography variant="caption" color="text.secondary">
        Opened from:
      </Typography>
      {contextLink ? (
        <Chip
          size="small"
          icon={buildContextIcon(contextData?.screen)}
          label={contextLabel}
          onClick={() => onNavigate(contextLink)}
          clickable
          color="primary"
          variant="outlined"
        />
      ) : (
        <Chip size="small" icon={buildContextIcon(contextData?.screen)} label={contextLabel} />
      )}
    </Box>
  );
};

export default FidesChatContextBar;
